

export enum StateNames {
    'what-to-do-detail'= 'whatToDo',
    'where-to-eat-and-drink-detail' = "whereToEat",
    'how-to-move-around-detail' = 'howToMoveAround',
    'what-is-extra-detail' = 'whatsExtra'
}